import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EPostbackMethods, IPostbackForm } from 'entities/Postback';

interface IPostbackSlice {
	values: IPostbackForm;
}

const initialState: IPostbackSlice = {
	values: { method: 'get' as EPostbackMethods, action_statuses: [], protocol: 'https://', url: '', params: [] },
};

export const postbackSlice = createSlice({
	name: 'source',
	initialState,
	reducers: {
		setValues: (state, action: PayloadAction<IPostbackForm>) => {
			state.values = action.payload;
		},
		clearValues: (state) => {
			state.values = initialState.values;
		},
	},
});

export default postbackSlice.reducer;
export const { setValues, clearValues } = postbackSlice.actions;
